import { Check, MessageSquare } from 'lucide-react';
import { Button } from '@strivelabs/ui-core/v2';
import { CLOSED_STATUSES } from '../statusMeta';
import type { Task } from '@/types/task';

interface TaskDetailFooterProps {
  task: Task;
  /** What the primary action is called where this panel is hosted. */
  ctaLabel: string;
  onMarkDone: () => void;
  onOpenInChat: () => void;
}

/**
 * The panel's actions. "Mark as Done" is hidden once a task is finished or
 * dismissed, where it would have nothing left to do.
 */
export const TaskDetailFooter = ({
  task, ctaLabel, onMarkDone, onOpenInChat,
}: TaskDetailFooterProps) => (
  <div className="flex shrink-0 items-center justify-end gap-[9px] border-t border-[rgba(0,0,0,0.08)] bg-white px-4 py-3">
    {CLOSED_STATUSES.includes(task.status) ? null : (
      <Button variant="secondary" icon={<Check aria-hidden />} onClick={onMarkDone}>
        Mark as Done
      </Button>
    )}
    <Button className="min-w-0" icon={<MessageSquare aria-hidden />} onClick={onOpenInChat}>
      <span className="truncate">{ctaLabel}</span>
    </Button>
  </div>
);
